import React, { Suspense, Component, lazy, useRef, useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { Modal, message } from 'antd';
import store from '../../store/store';
import { Provider } from 'react-redux';
import qs from 'qs';
import axios from 'axios';
import {
  _get_dicts,
  _get_system_params,
  _get_client_info,
  _change_ds_modal,
  _show_login_modal,
  _anly_seng_custom,
  _upload_client_log_file,
  _dssp_close_page,
  _dssp_open_page,
} from '../../store/Action';
// import asyncComponent from '../../components/asyncComponent';
import NewLogin from '../../components/newLogin/newLogin';
import ChatNim from '../../components/chatNim/ChatNim';
import BindPhone from '../../components/bindPhone/BindPhone';
import TipOff from '../../components/tipoff/TipOff';
import AwardModal from '../../components/awardModal/AwardModal';
import PerfectModal from '../../components/perfectModal/perfectModal';
import PwdModal from '../../components/pwdModal/PwdModal';
import SetRemark from '../../components/setRemark/SetRemark';
import VerificationRoom from '../../components/verificationRoom';
import Authentication from '../../components/center/authentication/Authentication';
import BrowserWarn from '../../components/browserWarn';
import ConnectState from '../../components/connectState';
import WEBROOM from '../../store/WebRoom';
import WEBIM from '../../store/WebNim';
import Util from '../../script/util';
import { DDLoading } from '../../components/globalPageStatus';
import jxCaptchaVerifiedHOC from '../../components/jxCaptchaVerifiedHOC';
import ModalDownQR from '../../components/center/modalDownQR/ModalDownQR';
import HTTP from '../../script/service';
import GodEnter from '../../components/godEnter';
import DsMainNew from '../../components/dsMain/DsMainNew';
import AffinityInvite from '../../components/affinityModal/AffinityInvite';
import AffinitySpace from '../../components/affinityModal/AffinitySpace';
import AffinityGive from '../../components/affinityModal/AffinityGive';
import AffinityInvitation from '../../components/affinityModal/AffinityInvitation';
import AffinityDetail from '../../components/affinityModal/AffinityDetail';
import InterestAffinityDetail from '../../components/affinityModal/InterestAffinityDetail';
import DeleteAffinity from '../../components/affinityModal/DeleteAffinity';
import IDCardAuth from '../../components/center/authentication/IDCardAuth';
import RiskManage from '../../components/center/riskManage';
import RealNameCom from '../../components/center/riskManage/components/RealNameCom';
import GlobalIframeModal from '../../components/iframModal/GlobalIframeModal';
import SafeVerifyInputModal from '../../components/safeVerifyInputModal';
import WindowAction from '../../components/window/Action';
import ElectronExeUpdateModal from '../../components/clientUpdate/electronExe';
import DressUpMallModal from '../../components/dressUpMallModal';
import { SHWBLoginAuthModal } from '../../components/newLogin/SHWBLogin';
import SpeedOrderModal from '../../components/speedOrderModal';
import './index.scss';

// 主路由
const Home = lazy(() => import('../home/Page'));
const Room = lazy(() => import('../room/Page'));
const Stick = lazy(() => import('../stick/Stick'));
const NotFound = lazy(() => import('../notFound/NotFound'));
const Upgrade = lazy(() => import('../upgrade/Upgrade'));

// 首页子路由
const Index = lazy(() => import('../index/IndexNew'));
const Noob = lazy(() => import('../noob/Noob'));
const Hall = lazy(() => import('../hall/Hall'));
const PK = lazy(() => import('../pk/PK'));
const Activity = lazy(() => import('../activity/ActivityNew'));
const GameRoom = lazy(() => import('../gameroom/index'));

const RouteListener = () => {
  const location = useLocation();
  const oldLocation = useRef(null);

  useEffect(() => {
    return () => {
      _dssp_close_page(location);
    };
  }, []);

  useEffect(() => {
    _dssp_open_page(location);

    if (oldLocation.current) {
      _dssp_close_page(oldLocation.current);
    }
    oldLocation.current = location;
  }, [location]);

  return null;
};

class MainApp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      base: store.getState(),
      loading: true,
      update_visible: false,
      info: { version: '3.1.4' },
      downProcess: 0, // 下载进度
      downSuccess: false, // 下载成功
      downError: null, // 下载异常
      isShowUpdateElectron: false, // 是否显示electron更新弹窗
    };
  }
  // 检测 ele 版本
  updateStart = (info) => {
    const { client } = store.getState();
    store.dispatch({
      type: 'ele_client_update_info',
      data: { eleClientUpdateInfo: info },
    });
    //家庭版才显示自动更新
    if (client === 'ELE') {
      if (window.eleEvents?.versionCode > 316) {
        const isShowUpdateTip = window.localStorage.getItem(
          'dd-electron-update-tip'
        );
        if (isShowUpdateTip != 1) {
          this.setState({ isShowUpdateElectron: true, info });
        }
      } else {
        this.setState({ update_visible: true, info });
      }
    } else if (client === 'UELE') {
      if (window.eleEvents?.versionCode > 316) {
        const isShowUpdateTip = window.localStorage.getItem(
          'dd-electron-update-tip'
        );
        if (isShowUpdateTip != 1) {
          this.setState({ isShowUpdateElectron: true, info });
        }
      }
    }
  };
  // 检测没有可更新的文件
  updateNot = (info) => {
    // 手动点击右下角检查更新图标
    if (!!info?.clickCheck) {
      message.info('当前是最新版本，无可更新的版本');
    }
  };
  // 更新下载进度
  updateProgress = (info) => {
    if (info?.percent) {
      const process = parseFloat(info.percent).toFixed(2);
      this.setState({ downProcess: process, downError: null });
    }
  };
  updateError = (info) => {
    if (info?.name || info?.errorMsg) {
      // const name = info.name;
      let msg = info?.errorMsg || info.message;
      // const stack = info.stack;
      if (msg) {
        if (msg.indexOf('sha512 checksum mismatch') > -1) {
          msg = '文件校验失败，请重试';
        } else if (msg.indexOf('ERR_SSL_PROTOCOL_ERROR') > -1) {
          msg = '检查更新失败，可手动检查更新';
        } else if (msg.indexOf('404') > -1 && msg.indexOf('Not Found') > -1) {
          msg = '获取更新文件失败，请稍后重试，或手动去官网进行更新';
        } else if (msg.indexOf('status 403:') > -1) {
          msg = '获取新版本异常，请稍后重试，或手动去官网进行更新';
        }
      }
      if (!msg) msg = '获取更新失败，请稍后重试';
      message.warning(msg);
      this.setState({ downError: msg });
    } else {
      const { client, clientInfo } = store.getState();
      this.setState(
        { update_visible: false, isShowUpdateElectron: false },
        () => {
          this.upgradeClient = false;
          let upgrade = window.location.href.indexOf('upgrade') == -1;
          let stick = window.location.href.indexOf('stick') == -1;
          let v = parseInt(clientInfo.version.replace(/\./g, ''));
          if (!upgrade || !stick) {
            this.upgradeClient = false;
          } else if (client == 'UELE' && v <= 305) {
            this.upgradeClient = true;
          } else {
            this.upgradeClient = true;
          }
          if (this.upgradeClient) {
            // this.routerDom && this.routerDom.history.replace('/upgrade' + window.location.search);
            console.error('客户端-强制版本升级', clientInfo);
          } else {
            message.warning('更新失败，如果多次失败请前往官网下载最新版本');
          }
        }
      );
    }
  };
  // 更新下载完成
  updateDownloaded = () => {
    this.setState({
      isShowUpdateElectron: true,
      downSuccess: true,
      downProcess: 100,
    });
  };
  appReload = (fn) => {
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: <span>您确定要重新启动应用吗?</span>,
      className: 'daidai-confirm-style',
      cancelText: '取消',
      okText: '确定',
      centered: true,
      onOk: () => {
        WEBROOM.disconnectRoom().then(() => {
          fn && fn();
        });
      },
    });
  };
  appClearAll = (fn) => {
    Modal.confirm({
      title: '提示',
      icon: null,
      closable: true,
      content: (
        <div>
          <span>您确定要所有缓存记录吗?</span>
          <p style={{ fontSize: 12, color: '#f90' }}>
            所有用户设置以及用户登录状态都会被清除
          </p>
        </div>
      ),
      className: 'daidai-confirm-style',
      cancelText: '取消',
      okText: '确定',
      centered: true,
      onOk: () => {
        fn && fn();
      },
    });
  };
  // 右下脚点击退出时的弹窗
  appClose = () => {
    this.windowActionEle && this.windowActionEle.windowClose();
  };
  checkClientVersion = ({ client, clientInfo, upgrade, stick }) => {
    return new Promise((resolve, reject) => {
      this.upgradeClient = false;
      if (!upgrade || !stick) {
        this.upgradeClient = false;
      } else if ((client == 'UELE' || client == 'ELE') && clientInfo.version) {
        let v = parseInt(clientInfo.version.replace(/\./g, ''));
        if (v <= 305) this.upgradeClient = true;
      }
      resolve(!this.upgradeClient);
    });
  };
  async componentDidMount() {
    WEBIM.onConfigFn('OPEN_CAPTCHA_VERIFIED', this.openCaptchaVerified);

    try {
      const { rootConfig } = store.getState();
      if (window.eleEvents) {
        window.eleEvents.events['appUpdateStart'] = this.updateStart;
        window.eleEvents.events['appUpdateNot'] = this.updateNot;
        window.eleEvents.events['appUpdateProgress'] = this.updateProgress;
        window.eleEvents.events['appUpdateError'] = this.updateError;
        window.eleEvents.events['appUpdateDownloaded'] = this.updateDownloaded;
        window.eleEvents.events['appReload'] = this.appReload;
        window.eleEvents.events['appClearAll'] = this.appClearAll;
        window.eleEvents.events['appClose'] = this.appClose;
      }
      if (window.location.href.indexOf('inner=pc') != -1) {
        document.body.className = `client-pc ${rootConfig.companyCode}`;
      } else {
        document.body.className = `client-web ${rootConfig.companyCode}`;
      }
      if (window.location.href.indexOf('scale=') != -1) {
        const search = window.location.search.replace('?', '');
        const search_json = qs.parse(search);
        const scale = search_json && search_json.scale ? search_json.scale : 1;
        document.body.className = `client-web scale-test ${rootConfig.companyCode}`;
        document.body.style.transform = `scale(${scale})`;
      }
      await _get_client_info();
    } catch (error) {
      //未获取到客户端信息 || 当前是WEB场景
    } finally {
      // 获取系统参数
      _get_system_params(async () => {
        const { channelId, uid, client, rootConfig, clientInfo, wb_sid } = store.getState();
        let curChannelId = channelId;
        const pid = await this.getUELEPid();
        if (!!pid) {
          curChannelId = pid;
          store.dispatch({
            type: 'change_channel_id',
            data: { channelId: curChannelId },
          });
        }
        if (window._monitor_?.main?.updateConfigExtends) {
          uid && window._monitor_.main.updateConfigExtends("uid", uid);
          window._monitor_.main.updateConfigExtends("channelId", curChannelId);
          window._monitor_.main.updateConfigExtends("client", client);
          window._monitor_.main.updateConfigExtends("source", rootConfig.source);
          window._monitor_.main.updateConfigExtends("version", rootConfig.version);
          clientInfo?.version && window._monitor_.main.updateConfigExtends("clientVersion", clientInfo.version);
        }

        if (process.env.CLIENT_ENV !== 'production') return;
        const now = Date.now();
        const extendFields = { business_sessionid: `${now}${Math.random()}` };
        if (wb_sid) extendFields.sid = wb_sid;
        window.century_setting = {
          product_id: 320000, //不同产品线产品id,部署时写死
          os_type:
            client === 'ELE' || client === 'UELE' || client === 'PC' ? 7 : 1, // 页面部署的终端：1:web; 2：ios， 3、android   4、WAP（手机H5） 5：APP内嵌H5； 6：微信小程序 ； 7：PC客户端，由数据部统一管理
          channel_id: curChannelId, //渠道来源名字或者ID,可为空
          pid: '', // 渠道分包标识(计费),可为空
          qtd: '', // 友拓广告串联参数,可为空
          uid: uid, // 用户
          heart_duration: 60 * 1000, // 心跳的时间间隔，单位毫秒，间隔该时间，发送心跳数据，若不填，则默认不发送心跳数据，
          page_name: window.location.pathname,
          dssp_url: 2,
          no_sysinfo: false, // no_sysinfo:true 则不会默认请求
          extend_fields: JSON.stringify(extendFields),
        };
        if (!window.dssp_operate_click_timestamp)
          window.dssp_operate_click_timestamp = now;
        if (process.env.CLIENT_ENV == 'production') {
          let wb = document.createElement('script');
          wb.async = true;
          wb.src = '//sc.dsspinfo.com/websdkv2.1.js';
          document.head.appendChild(wb);
          // 异常数据上报SDK
          let anly = document.createElement('script');
          anly.src =
            '//log.daidaicp.com/sdk/anly-web-sdk-v1.0.0.min.js?v=' + Date.now();
          anly.onload = () => {
            //客户端版本升级
            if (this.upgradeClient)
              _anly_seng_custom(1800, { data: clientInfo });
            else setTimeout(_upload_client_log_file, 1000);
          };
          document.body.appendChild(anly);
        } else {
          let wb = document.createElement('script');
          wb.async = true;
          wb.src = '//dtsdk-test.dsspinfo.com/websdkv2.0.test.js';
          document.head.appendChild(wb);
          // 异常数据上报SDK
          /*let anly = document.createElement('script');
          anly.src = '//test.madouvip.com/sdk/anly-web-sdk-v1.0.0.min.js?v='+ Date.now();
          anly.onload = () => {
            //客户端版本升级
            if (this.upgradeClient) _anly_seng_custom(1800, { data: clientInfo });
            else setTimeout(_upload_client_log_file, 1000);
          };
          document.body.appendChild(anly);*/
        }

        // 监听点击事件
        window.addEventListener(
          'click',
          () => {
            const now = Date.now();
            if (
              !WEBROOM?.webrtc?.slefStream &&
              now - window.dssp_operate_click_timestamp > 30 * 60 * 1000
            ) {
              // 需要重置 sessionid
              window.century_setting.extend_fields = JSON.stringify({
                business_sessionid: `${now}${Math.random()}`,
              });
            }
            window.dssp_operate_click_timestamp = now; // 更新最后点击时间
          },
          true
        );

        // 监听页面挂载后台
        /*document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            // 离开页面
            console.info("离开页面")
          } else {
            // 进入页面
            console.info("进入页面")
          }
        }, false);*/
      });
      //获取数据字典
      _get_dicts(window.dicts).then(() => {
        const { uid, firstIn, dsid, jnid, clientInfo, client, serverSwitch } =
          store.getState();
        this.setState({ base: store.getState() }, () => {
          this.setState({ loading: false }); // 字典接口加载完成
        });
        let upgrade = window.location.href.indexOf('upgrade') == -1;
        let stick = window.location.href.indexOf('stick') == -1;
        this.checkClientVersion({ client, clientInfo, upgrade, stick }).then(
          (success) => {
            if (success === false) return;
            const isServerSwitch = serverSwitch?.switchStatus == 0; // 服务端是否在维护中 0: 正常 1:维护中
            //是否是首次进入
            if (upgrade && stick && !uid && isServerSwitch) {
              firstIn && _show_login_modal();
            }
            //进入大神主页
            if (dsid) {
              const ehot = !!Util.getParameters('ehot');
              _change_ds_modal({ dsid: dsid, jnid: jnid, ehot });
            }
          }
        );
      });
    }
  }
  // 唤起极验
  openCaptchaVerified = (sceneType = null) => {
    const {
      initCaptchaVerified,
      resetCaptchaVerified,
      getCaptchaVerified,
      destroyCaptchaVerified,
    } = this.props;
    initCaptchaVerified({ isGlobal: true, bizType: 1, geeType: 0 }, () => {
      const geeValidate = getCaptchaVerified();
      HTTP._post_risk_validate({ ...geeValidate, sceneType })
        .then(async (res) => {
          if (res?.code === 200) {
            destroyCaptchaVerified();
          } else {
            resetCaptchaVerified();
            message.warning(res?.message ?? '验证失败,请稍后重试');
            await Util.sleep(300);
            this.openCaptchaVerified();
          }
        })
        .catch((err) => {
          destroyCaptchaVerified();
          message.warning('验证失败，请稍后重试');
        });
    });
  };
  // PC免安装客户端获取PID
  getUELEPid = async () => {
    let pid = null;
    const { client } = store.getState();
    if (client === 'UELE') {
      try {
        const url = 'https://127.0.0.1:16222/getVal?key=320000';
        let result = await axios.get(url);
        if (result?.status === 200 && result?.data) {
          const content = decodeURIComponent(result.data);
          if (Util.isJSONStr(content)) {
            const data = JSON.parse(content);
            pid = data?.pid || null;
          } else {
            pid = result.data || null;
          }
        } else {
          pid = result?.data || null;
        }
      } catch (err) {
        console.error('--- get uele pid error ---', err.toString());
      }
    }
    return pid;
  };
  render() {
    const {
      info,
      base,
      loading,
      downProcess,
      downSuccess,
      downError,
      isShowUpdateElectron,
    } = this.state;
    const { channelId, rootConfig, isBlackRoom } = base;
    return (
      <Provider store={store}>
        <div
          className={`main-fix root-main-fix ${rootConfig.companyCode} channelId_${channelId}`}
        >
          <BrowserRouter>
            <div className="main-router">
              <Suspense
                fallback={
                  <DDLoading className="app-updater-loading" status>
                    <div className="empty-dom" />
                  </DDLoading>
                }
              >
                {rootConfig.lang == 'zh_CN' &&
                !!base?.serverSwitch?.switchStatus ? (
                  <div
                    className="no-server"
                    style={{
                      backgroundImage: `url(${Util.transImgUrl(base.serverSwitch.pcUrl)})`,
                    }}
                  />
                ) : (
                  !loading && (
                    <>
                      <RouteListener />
                      <Routes>
                        <Route
                          path="/"
                          element={<Navigate to={`/index`} replace />}
                        />
                        <Route path="/index" element={<Home />}>
                          <Route
                            path=""
                            element={
                              <Navigate to={`main${location.search}`} replace />
                            }
                          />
                          <Route path="main" element={<Index />} />
                          <Route path="noob" element={<Noob />} />
                          <Route path="hall" element={<Hall />} />
                          <Route path="pk" element={<PK />} />
                          <Route path="activity" element={<Activity />} />
                          <Route path="groom" element={<GameRoom />} />
                          <Route path="error" element={<Stick />} />
                          <Route path="*" element={<NotFound />} />
                        </Route>
                        <Route path="/room" element={<Room />} />
                        <Route path="/upgrade" element={<Upgrade />} />
                        <Route path="error" element={<Stick />} />
                        <Route path="*" element={<NotFound />} />
                      </Routes>
                    </>
                  )
                )}

                <WindowAction
                  wrappedComponentRef={(el) => (this.windowActionEle = el)}
                  base={base}
                />
              </Suspense>
              {/* 更新弹窗 */}
              <ElectronExeUpdateModal
                base={base}
                visible={isShowUpdateElectron}
                info={info}
                changeError={(bool) => this.setState({ downError: bool })}
                downError={downError}
                downProcess={downProcess}
                downSuccess={downSuccess}
                closeModal={() =>
                  this.setState({ isShowUpdateElectron: false })
                }
              />
              {/* 登录模块 */}
              <NewLogin />
              {/* 完善用户信息 */}
              <PerfectModal />
              {/* 手机绑定 */}
              <BindPhone />
              {/* 大神主页 */}
              <DsMainNew />
              {/* 亲密关系 */}
              <AffinityInvite />
              {/* 亲密关系邀请函 */}
              <AffinityInvitation />
              {/* 亲密关系邀请详情 */}
              <AffinityDetail />
              {/* 亲密空间 */}
              <AffinitySpace />
              {/* 亲密关系赠送 */}
              <AffinityGive />
              {/* 趣味关系 */}
              <InterestAffinityDetail />
              {/* 亲密关系解除 */}
              <DeleteAffinity />
              {/* 急速点单弹窗 */}
              <SpeedOrderModal />
              {/* 聊天窗口 */}
              <ChatNim />
              {/* 举报 */}
              <TipOff />
              {/* 奖励弹窗 */}
              <AwardModal />
              {/* 设置密码弹窗 */}
              <PwdModal />
              {/* 设置备注弹窗 */}
              <SetRemark />
              {/* 房间密码验证 */}
              <VerificationRoom />
              {/* 实名弹窗 */}
              <Authentication />
              {/* 浏览器兼容弹窗 */}
              <BrowserWarn />
              {/* 长连接状态 */}
              <ConnectState />
              {/* 实名认证 */}
              <ModalDownQR />
              {/* 实名认证填写 */}
              <IDCardAuth />
              {/* 风控管理 */}
              <RiskManage />
              {/* 通用实名认证 */}
              <RealNameCom />
              {/* 全局 iframe 弹窗 */}
              <GlobalIframeModal />
              {/* 消费安全码 */}
              <SafeVerifyInputModal />
              {/* 大神入驻 */}
              <GodEnter />
              {/* 装扮商城 */}
              <DressUpMallModal />
              {/* 四合网吧授权登录提示 */}
              <SHWBLoginAuthModal />
            </div>
          </BrowserRouter>
          {/* todo 2023.10.19 百助推广指定渠道PIDQk2YpehYF隐藏公司信息 */}
          {channelId !== 'PIDQk2YpehYF' && (
            <div className="root-foot-icp">
              <p>
                <a
                  href={`${rootConfig?.protocolPath || rootConfig.mobilePath}/appagreement/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  用户协议
                </a>
                <a
                  href={`${rootConfig?.protocolPath || rootConfig.mobilePath}/privacy/`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  隐私策略
                </a>
                <a
                  href={`${rootConfig?.protocolPath || rootConfig.mobilePath}/permissionsList/#/permissions-list`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  权限列表
                </a>
                <span>版本号：{rootConfig.version}</span>
                <span>开发者名称：{rootConfig.companyConfig.companyName}</span>
              </p>
              <p>
                {rootConfig?.lang === 'zh_CN' && (
                  <span>备案号：{rootConfig.companyConfig.record}</span>
                )}
                {rootConfig?.lang === 'zh_CN' && (
                  <span>软著登记号：2022SRE018061</span>
                )}
                <span>公司地址：{rootConfig.companyConfig.address}</span>
              </p>
              <p>
                <span>带带陪玩</span>
                <a
                  href={`${rootConfig.mobilePath}/permissionsList/#/products-function`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  产品功能
                </a>
              </p>
            </div>
          )}
        </div>
      </Provider>
    );
  }
}

export default jxCaptchaVerifiedHOC(MainApp);
